import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSticker: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="sticker, badge" maskId="round-filled-radius-0-stroke-1.5-IconSticker"><path fillRule="evenodd" clipRule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C12.375 2 12.7454 2.02067 13.1102 2.061C13.2796 2.07972 13.4376 2.1556 13.5581 2.27612L21.7239 10.4419C21.8444 10.5624 21.9203 10.7204 21.939 10.8898C21.9793 11.2546 22 11.625 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM20.5 11.4506C16.0039 11.9923 12.0078 7.99591 12.5494 3.5L20.5 11.4506Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSticker;
